// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3l9QS","Loader":"App_Loader__3G9Tm","dotAnim":"App_dotAnim__kXxbO"};